import { Button, CircularProgress, Grid, Paper } from '@material-ui/core';
import React, { useCallback, useState } from 'react';
import Dropzone from 'react-dropzone';
import './App.css';
import ExportModal from './components/ExportModal';
import FareTable from './components/FaresTable';
import PriceModal from './components/PriceModal';
import { Fare } from './Models';
import { parseFile } from './utils/importer';

function App() {
  let [fares, setFares] = useState<Fare[]>([]);
  let [displayedFare, setDisplayedFare] = useState<Fare | undefined>(undefined);
  let [displayExportModal, setDisplayExportModal] = useState<boolean>(false);
  let [importingData, setImportingData] = useState<boolean>(false);
  const onDrop = useCallback(async (acceptedFiles: File[]) => {
    if (acceptedFiles.length === 1) {
      setImportingData(true);
      console.log('Fichier reçu: ', acceptedFiles);
      const fares = await parseFile(acceptedFiles[0]);
      setFares(fares);
    }
  }, []);

  const renderDropZone = () => {
    return (
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justify="center"
        style={{ minHeight: '100vh' }}
      >
        <Grid item xs={3}>
          <Dropzone accept="text/csv" onDrop={onDrop}>
            {({ getRootProps, getInputProps }) => (
              <section>
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <Paper elevation={6}>
                    <div
                      style={{
                        background: '#EEEEEE',
                        width: '500px',
                        height: '500px',
                      }}
                    >
                      {importingData && (
                        <>
                          <h2>Import en cours</h2>
                          <CircularProgress color="secondary" />
                        </>
                      )}
                      {!importingData && (
                        <>
                          <h2>Déposer ici un fichier CSV</h2>
                        </>
                      )}{' '}
                    </div>
                  </Paper>
                </div>
              </section>
            )}
          </Dropzone>
        </Grid>
      </Grid>
    );
  };

  const onRowClick = (fare: Fare) => {
    setDisplayedFare(fare);
  };

  return (
    <div className="App">
      {displayedFare && (
        <PriceModal
          fare={displayedFare}
          onClose={() => {
            setDisplayedFare(undefined);
          }}
        ></PriceModal>
      )}
      {fares.length === 0 && renderDropZone()}
      {displayExportModal && (
        <ExportModal
          fares={fares}
          onClose={() => {
            setDisplayExportModal(false);
          }}
        ></ExportModal>
      )}
      {fares.length > 0 && (
        <Paper style={{ padding: '24px' }}>
          <Button
            onClick={() => {
              setDisplayExportModal(true);
            }}
          >
            Exporter tous les tarifs
          </Button>
          <FareTable
            fares={fares}
            onRowClick={(fare) => {
              setDisplayedFare(fare);
            }}
          ></FareTable>
        </Paper>
      )}
    </div>
  );
}

export default App;
